import type { FieldingGroup, StepBase } from '@highlight-cp/project-api';

import { getStepDuration } from '../utils/get-step-duration';

export const getFieldingGroupStepsDuration = (steps: StepBase[] | null | undefined): number =>
  (steps ?? []).map(getStepDuration).reduce((acc, curr) => acc + curr, 0);

export const computeDaysToCompleteFielding = (
  fieldingGroups: FieldingGroup[] | null | undefined,
): number => {
  const durations = fieldingGroups?.map((fg) => getFieldingGroupStepsDuration(fg.steps)) ?? [];

  return Math.max(0, ...durations);
};
